<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Доступно обновление</h2>
        <button type="button" class="close" @click="$emit('hide')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Требуется перезагрузка страницы для загрузки новой версии
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" @click="reload">Перезагрузить</button>
        <button type="button" class="btn btn-light" @click="$emit('hide')">Отмена</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      reload () {
        window.location.reload()
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/release-modal.vue